
export const getters = {
    getContaPagar: state => state.contaPagar,
    getContasPagar: state => state.contasPagar,
    getModalCadastroContaPagar: state => state.modalCadastrarContaPagar,
    getModalBaixaContaPagar: state => state.modalBaixaContaPagar,
    getModalExcluirContaPagar: state => state.modalExcluirContaPagar,
    getModalPesquisarContaPagar: state => state.modalPesquisarContaPagar,
    getContaPagarSituacoes: state => state.contaPagarSituacoes,
    getContaPagarPortadores: state => state.contaPagarPortadores,
    getContaPagarFormasPagamento: state => state.contaPagarFormasPagamento,
    getContaPagarOcorrenciaTipos: state => state.contaPagarOcorrenciaTipos,
    getContaPagarOcorrencias: state => state.contaPagarOcorrencias,
    getShowInputAnexo: state => state.showInputAnexo,
}

export default {}